export const selectedOptionsMap = {
    report: 'H',
    file: 'X',
    excel: 'x',
    protectedexcel: 'p',
    graph: 'J',
    table: 'I'
};
